import Banner from "../layout/Banner";
import SpaceFiller from "../layout/SpaceFiller";
import Navbar from "../landing/Navbar";
import Footer from "../footer/Footer";

export default function Template({
  navbarMode = "transparent",
  footerBgColour = "off-white",
  children,
}: {
  navbarMode?: "transparent" | "solid";
  footerBgColour?: string;
  children: React.ReactNode;
}) {
  return (
    <>
      <Navbar mode={navbarMode} />
      <SpaceFiller className="bg-off-white" verticalPosition="start">
        {/* `w-full`, not `w-screen`: 100vw includes the vertical scrollbar, so on
            every page that scrolls, main was 8-17px wider than the space it had
            and the whole document scrolled sideways.

            `overflow-x-clip` contains the decorative bubbles. They are positioned
            with negative offsets (`-right-8`, `-right-28`…) so they peek past the
            section edge by design, but nothing was clipping them, so each one
            extended the document and produced a horizontal scrollbar. `clip`
            rather than `hidden` deliberately: `hidden` would make main a scroll
            container and break `position: sticky` inside it. */}
        <main className="w-full overflow-x-clip bg-off-white">{children}</main>

        {/* Alert banner */}
        <Banner />
      </SpaceFiller>

      {/* Footer */}
      <Footer bgColour={footerBgColour} />
    </>
  );
}
